export default "__VITE_ASSET__BtFq4Bj0__"